<template>
    <div class="open_matter">
        <el-card class="common_matter" shadow="never">
            <div class="title">
                <p>今日开标/竞价项目 <span class="badge_defult" :class="openDataTotal&&openDataTotal>0?'badge_red':null">{{openDataTotal|more99Filter}}</span></p>
                <el-button type="text" class="btn" @click="apijwtToField">查看一周开评标场地表</el-button>
                <el-input class="title_input" placeholder="请输入项目编号/名称" v-model="openSearchkey">
                    <i slot="suffix" class="el-input__icon el-icon-search" @click="apiworkBenchIndexProjectIndex"></i>
                </el-input>
            </div>
            <div class="open_matter--con" v-loading="loading">
                <el-carousel class="carousel_div" :interval="8000">
                    <el-carousel-item></el-carousel-item>
                </el-carousel>
            </div>
        </el-card>
    </div>
</template>

<script>
import {
	apiAuditList,apiwbschedulemanagementlist,apiworkBenchIndexProjectIndex,
	apiAuditCount,apijwtToJsgc,apijwtToZfcg,apijwtToBjm,apijwtToField,apiwbschedulemanagementupdateCompleteStatus,
	apiwbschedulemanagementdelete,apiwbschedulemanagementmove,apiwbconveniententranceconvenientEntranceList,
	apiwbconveniententrancedelete,apiwbconveniententrancedeleteCustomize,
	apiwbconveniententrancesort,apijwtToSystem,apifilePath} from '@/server/common';
import {group} from '@/utils/index';

export default {
    data(){
        return {
            loading:false,
            openData: [],
            openSearchkey: '',
            openDataTotal: 0,
        }
    },
    created(){},
    methods:{
        apijwtToField(){
            apijwtToField().then(({data})=>{
				if(data.code=='1'){
					window.open(data.data)
				}else{
					this.$alert(data.msg);
				}
			})
        },
        apiworkBenchIndexProjectIndex(){
			this.openLoading=true;
			apiworkBenchIndexProjectIndex({
				page:1,
                rows:100,
				searchKey:this.openSearchkey
			}).then(({data})=>{
				this.openData=group(data.rows||[],4);
				this.openDataTotal=data.total||0;
			}).finally(()=>{this.openLoading=false;})
		},
    }
}
</script>

<style lang="less" scoped>
.open_matter{
    height: 100%;
    .common_matter,/deep/ .el-card__body{
        height: 100%;
    }
    .title{
        .btn{
            margin-left: 20px;
        }
        .title_input{
            margin-left: auto;
            width: 18%;
            min-width: 200px;
        }
    }
    .open_matter--con{
        height: calc(100% - 50px);
    }
}
</style>